module.exports = __webpack_public_path__ + "static/img/ikonaMuzykaDisabled-OFF.58fa73fb.png";